const PaginationError = () => {
  return (
    <div className="flex items-center justify-center rounded-md border border-dashed border-border-gray bg-gray-50 p-8">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-gray-800">
          Pagination Exceeded
        </h3>
        <p className="mt-2 text-sm text-gray-600">
          Please request an export or order to view more
        </p>
      </div>
    </div>
  )
}

export default PaginationError
